import { getSuppliers } from '../../../HttpRequests/suppliers';
import { setFetching } from '../State/fetching';
import { loadSuppliers } from '../State/suppliers';
import { setPagination } from '../State/pagination';
import handleException from '../../../Core/Helpers/handleException';

export default () => async (dispatch, getState) => {

  const { pagination, sorting, searchTerm, filters } = getState().screens.Suppliers;

  try {

    const params = {};

    params.page = pagination.current;
    params.per_page = pagination.pageSize;

    if (sorting.columnKey) {
      params.sort_by = sorting.columnKey;
      params.sort_order = sorting.order === 'descend' ? 'desc' : 'asc';
    }

    if (searchTerm) {
      params.search = searchTerm;
    }

    if (filters.active !== 'all') {
      params.active = filters.active === 'active' ? 1 : 0;
    }

    dispatch(setFetching(true));

    const response = await getSuppliers({ params });

    dispatch(loadSuppliers(response.data.rows));

    dispatch(setPagination({
      total: response.data.pagination.total,
      pageSize: response.data.pagination.per_page,
      current: response.data.pagination.current_page
    }));

    dispatch(setFetching(false))

  } catch (error) {

    handleException(error);
    dispatch(setFetching(false));
  }
}
